var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useCallback, useState, createRef } from "react";
import Web3 from "web3";
import { QubicConnector } from "@qubic-js/react";
import { Web3ReactProvider, useWeb3React } from "@web3-react/core";
import qs from "query-string";
import ReactGA from "react-ga4";
import { InjectedConnector } from "@web3-react/injected-connector";
import dialogPolyfill from "dialog-polyfill";
import ActiveSpinner from "@/components/ActiveSpinner";
import { QUBIC_API_KEY, QUBIC_API_SECRET } from "../../constants/variable";
import InlineDownloadButtons from "../InlineDownloadButtons/InlineDownloadButtons";
import { CLIENT, GA_TRACKING_ID } from "../../constants";
import FacebookFill from "../../assets/ic_facebook_fill.svg";
import InstagramFill from "../../assets/ic_instagram_fill.svg";
import TwitterFill from "../../assets/ic_twitter_fill.svg";
import DiscordFill from "../../assets/ic_discord_fill.svg";
import CheckFill from "../../assets/ic_check_circle_green_fill.svg";
import QubicLogin from "../../assets/qubic-login.svg";
import MetamaskFox from "../../assets/metamask-fox.svg";
import "./App.sass";
import { SUPPORTED_CHAIN_IDS } from "../../constants/blockchain";
import LogoQubic from "../../assets/logo-qubic.svg";
import LogoAorus from "../../assets/logo-aorus.svg";
import ImgAorusFalconWarriors from "../../assets/img-aorus-falcon-warriors.jpg";
var qubicConnector = new QubicConnector({
    apiKey: QUBIC_API_KEY || "b5a6bfea-553c-4640-8494-e14e8b2ae155",
    apiSecret: QUBIC_API_SECRET || "WfVkkGUsdCHHFDjCBAjNKNMoTqFSOLiF",
    chainId: 1,
    infuraProjectId: "",
    // optional, default: false, when value is true, the popup will hide automatically
    autoHideWelcome: false,
    // optional, default: false, when value is true, the show iframe instead of new window, credit card payment will failed with this option value true
    enableIframe: false,
});
var App = function () {
    useEffect(function () {
        ReactGA.initialize([
            {
                trackingId: GA_TRACKING_ID,
            },
        ]);
        ReactGA.send("pageview");
    }, []);
    var context = useWeb3React();
    var account = context.account, activate = context.activate;
    var _a = qs.parse(window.location.search), _b = _a.client, client = _b === void 0 ? CLIENT : _b, _c = _a.tag, tag = _c === void 0 ? "" : _c;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), done = _e[0], setDone = _e[1];
    var dialogRef = createRef();
    useEffect(function () {
        if (done || !account)
            return;
        fetch(qs.stringifyUrl({
            url: "https://script.google.com/macros/s/AKfycbzqZLQGvmSpufM8PWHEgfD2QIjlUZU-4NkoB7oCJpuuBhVsRMUE-V_p-MLoQkk8d_GTKA/exec",
            query: {
                client: client,
                tag: tag,
                address: account,
            },
        }))
            .then(function (res) { return res.json(); })
            .then(function (result) {
            var status = result.status;
            if (status === "success") {
                setLoading(false);
                setDone(true);
            }
        });
    }, [done, account, client, tag]);
    useEffect(function () {
        if (dialogRef.current) {
            dialogPolyfill.registerDialog(dialogRef.current);
        }
    }, [dialogRef]);
    var handleDesktopSignIn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (dialogRef.current) {
                // @ts-ignore
                dialogRef.current.showModal();
            }
            return [2 /*return*/];
        });
    }); }, [dialogRef]);
    var handleQubicLoginIn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dialogRef.current) {
                        // @ts-ignore
                        dialogRef.current.close();
                    }
                    setLoading(true);
                    return [4 /*yield*/, activate(qubicConnector, function (e) {
                            console.error("Qubic Wallet login ERROR", e);
                            alert("Please login Qubic Wallet to continue");
                            setLoading(false);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [activate, dialogRef]);
    var handleLoginMetaMask = useCallback(function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var dappConnector;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ev === null || ev === void 0 ? void 0 : ev.preventDefault();
                    if (!window.ethereum ||
                        (window.ethereum && !window.ethereum.isMetaMask)) {
                        alert("Please install MetaMask extension or use the MetaMask App in-app browser to open");
                        return [2 /*return*/];
                    }
                    if (dialogRef.current) {
                        // @ts-ignore
                        dialogRef.current.close();
                    }
                    setLoading(true);
                    dappConnector = new InjectedConnector({
                        supportedChainIds: SUPPORTED_CHAIN_IDS,
                    });
                    if (!(dappConnector && typeof window !== "undefined")) return [3 /*break*/, 2];
                    return [4 /*yield*/, activate(dappConnector, function (e) {
                            console.error("Metamask login ERROR", e);
                            alert("Please connect Metamask to continue");
                            setLoading(false);
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [activate, dialogRef]);
    var handleMobileSignIn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.ethereum && window.ethereum.isMetaMask) {
                        handleLoginMetaMask();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, activate(qubicConnector, function (e) {
                            console.error(e);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [activate, handleLoginMetaMask]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "App" }, { children: [_jsxs("header", { children: [_jsx("img", { src: LogoAorus, alt: "Aorus" }, void 0), _jsx("div", __assign({ className: "cross" }, { children: "x" }), void 0), _jsx("img", { src: LogoQubic, alt: "Qubic" }, void 0)] }, void 0), _jsx("main", { children: _jsxs("div", __assign({ className: "content" }, { children: [_jsx("div", { children: _jsx("section", __assign({ className: "asset" }, { children: _jsx("div", __assign({ className: "card" }, { children: _jsxs("div", __assign({ className: "media-mask" }, { children: [_jsx("img", { src: ImgAorusFalconWarriors, alt: "Aorus Falcon Warriors" }, void 0), done || loading ? (_jsx("div", __assign({ className: "redeemed" }, { children: done ? (_jsx(_Fragment, { children: _jsx("img", { className: "img", src: CheckFill, alt: "Green Check" }, void 0) }, void 0)) : (_jsx(_Fragment, { children: _jsx(ActiveSpinner, { size: "2rem" }, void 0) }, void 0)) }), void 0)) : null] }), void 0) }), void 0) }), void 0) }, void 0), _jsx("div", { children: _jsxs("section", __assign({ className: "info" }, { children: [_jsx("div", __assign({ className: "description" }, { children: !done ? (_jsxs(_Fragment, { children: [_jsx("h3", { children: "AORUS Falcon Warriors" }, void 0), _jsx("p", { children: "AORUS is a brand under GIGABYTE. AORUS Falcon Warriors is the Web3 team from AORUS, and a brand that pushes creativity and innovation through exploring the creative mind." }, void 0), _jsx("p", { children: "Our mission is to push and break barriers when it comes to creating a new type of digital ecosystem that can serve as the frontier interactive space for our communities." }, void 0), _jsx("p", { children: "AORUS Falcon Warriors Club is a collection of 777 randomly generated NFTs that double as your AFW Club membership card, and grant access to members-only benefits. Future areas and perks can be unlocked by the community through roadmap activation." }, void 0), _jsx("h4", { children: "It\u2019s an airdrop! No minting fee. No gas fee." }, void 0), _jsx("p", { children: "All you have to do is to be active in the AFW community, and do your best to get on the whitelist!" }, void 0), _jsx("p", { children: "We are giving away 5 AFWC airdrop! Click the \"Register\" button below to sign up for the raffle!" }, void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Hooray" }, void 0), _jsx("p", __assign({ className: "paragraph" }, { children: "You're registered!" }), void 0), _jsx("p", __assign({ className: "paragraph" }, { children: "Stay tuned for the coming announcement in AFWC's Discord." }), void 0)] }, void 0)) }), void 0), done && (_jsx("div", __assign({ className: "download" }, { children: _jsx(InlineDownloadButtons, { spacing: 8, maxHeight: 54 }, void 0) }), void 0)), _jsx("div", __assign({ className: "button-group" }, { children: !done ? (_jsxs(_Fragment, { children: [_jsx("button", __assign({ className: "button desktopSignIn", onClick: handleDesktopSignIn }, { children: "Register" }), void 0), _jsx("button", __assign({ className: "button mobileSignIn", onClick: handleMobileSignIn }, { children: "Register" }), void 0)] }, void 0)) : null }), void 0)] }), void 0) }, void 0)] }), void 0) }, void 0), _jsxs("footer", { children: [_jsxs("div", __assign({ className: "social" }, { children: [_jsx("a", __assign({ href: "https://www.facebook.com/AorusOfficial/", target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { src: FacebookFill, alt: "Facebook" }, void 0) }), void 0), _jsx("a", __assign({ href: "https://www.instagram.com/aorus_official/", target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { src: InstagramFill, alt: "Instagram" }, void 0) }), void 0), _jsx("a", __assign({ href: "https://twitter.com/Falcon_Warriors", target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { src: TwitterFill, alt: "Twitter" }, void 0) }), void 0), _jsx("a", __assign({ href: "https://discord.com/invite/NvweGCFfpe", target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { src: DiscordFill, alt: "Discord" }, void 0) }), void 0)] }), void 0), _jsx("div", { children: "\u00A92022 GIGA-BYTE Technology Co., Ltd. All Rights Reserved." }, void 0)] }, void 0)] }), void 0), _jsx("dialog", __assign({ id: "loginDialog", ref: dialogRef }, { children: _jsxs("div", __assign({ className: "loginButtons" }, { children: [_jsxs("button", __assign({ className: "button loginButton", onClick: handleQubicLoginIn }, { children: [_jsx("span", __assign({ className: "buttonIcon" }, { children: _jsx("img", { src: QubicLogin, width: 48, height: 48, alt: "qubic-login-icon" }, void 0) }), void 0), "Qubic Wallet"] }), void 0), _jsxs("button", __assign({ className: "button loginButton", onClick: handleLoginMetaMask }, { children: [_jsx("span", __assign({ className: "buttonIcon" }, { children: _jsx("img", { src: MetamaskFox, width: 48, height: 48, alt: "metamask-login-icon" }, void 0) }), void 0), "MetaMask"] }), void 0)] }), void 0) }), void 0)] }, void 0));
};
export default React.memo(function () {
    var library = function (provider) {
        console.log({
            "provider.isQubic": provider.isQubic,
        });
        return new Web3(provider);
    };
    return (_jsx(Web3ReactProvider, __assign({ getLibrary: library }, { children: _jsx(App, {}, void 0) }), void 0));
});
